import React from 'react';

import type { HookProps } from './hooks/useVenmoButton';
import { useVenmoButton } from './hooks/useVenmoButton';

export type Props = HookProps & {
	loading: boolean;
	disabled: boolean;
};

export function VenmoButton(props: Props): React.JSX.Element | null {
	const {
		data: { ref },
		actions: { onClick },
	} = useVenmoButton(props);

	const { loading, disabled } = props;

	return (
		<div sx={{ textAlign: 'center' }}>
			<button
				ref={ref}
				onClick={onClick}
				type="button"
				disabled={loading || disabled}
				sx={{
					backgroundColor: loading || disabled ? '#008CFF91' : '#008CFF',
					width: ['100%', '300px'],
					borderRadius: '4px',
					cursor: 'pointer',
					padding: '5px',
					height: '45px',
				}}
			>
				<img
					src="https://static.change.org/payment-options/btn/venmo-white.svg"
					alt="venmo button logo"
					width="66"
					sx={{ paddingTop: '5px' }}
				/>
			</button>
		</div>
	);
}
